import _ from 'lodash';

const SET_FILTER = 'filters/SET_FILTER';
export const setFilter = ({field, value, namespace}) => ({
  type: SET_FILTER,
  payload: {
    field,
    value,
    namespace
  }
});

const SET_FILTERS = 'filters/SET_FILTERS';
export const setFilters = ({filters, namespace}) => ({
  type: SET_FILTERS,
  payload: {filters, namespace}
});

export const selectFilters = (state, namespace) =>
  _.get(state, `filters.${namespace}`, {});

export const OVERWRITE_FILTER_OBJECT = 'filters/OVERWRITE_FILTER_OBJECT';
export const overwriteFilterObject = ({filters, namespace}) => ({
  type: OVERWRITE_FILTER_OBJECT,
  payload: {filters, namespace}
});

export const FILTERS = {
  BOOKING_LIST: 'bookingList',
  BOOKING_TRACKER: 'bookingTracker',
  ALLOCATIONS_CALENDAR: 'allocationsCalendar',
  PURPOSES_CALENDAR: 'purposesCalendar',
  USERS_LIST: 'usersList',
  INVOICE_REPORTING_LIST: 'invoiceReportingList',
  AVAILABILITY: 'availability',
  PAYMENTS_LIST: 'paymentsList',
  NOTES_LIST: 'notesList',
  MEMBER_LIST: 'memberList',
  ROOM_LIST: 'roomList',
  BOOKING_SET_LIST: 'bookingSets',
  INTEGRATIONS_STATUS_LIST: 'integrationsStatusList',
  MY_TEAMS_TEAMS: 'myTeamsTeams',
  MY_TEAMS_MEMBERS: 'myTeamsMembers',
  CREDIT_NOTES_LIST: 'creditNotesList'
};

const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FILTER:
      return {
        ...state,
        [action.payload.namespace]: {
          ...state[action.payload.namespace],
          [action.payload.field]: action.payload.value
        }
      };

    case SET_FILTERS:
      return {
        ...state,
        [action.payload.namespace]: {
          ...state[action.payload.namespace],
          ...action.payload.filters
        }
      };

    case OVERWRITE_FILTER_OBJECT:
      return {
        ...state,
        [action.payload.namespace]: action.payload.filters
      };

    default:
      return state;
  }
};

export default reducer;
